const useAuthSendEmailConfirm = () => {
  const { t } = useI18n();
  const { openNotification } = useNotificationStore();
  const loading = ref(false);

  const sendEmailConfirm = async () => {
    loading.value = true;

    const { success } = await useAuthSendEmailConfirmDto();

    if (success) {
      openNotification(t("notifications.letterSubmit"));
    }

    loading.value = false;
  };

  return {
    loading,
    sendEmailConfirm,
  };
};

export { useAuthSendEmailConfirm };
